import { useCartUI } from '@context/CartContext';

import styles from './CartBadge.module.scss';

const CartBadge = () => {
  const { totalQuantity } = useCartUI();

  if (totalQuantity === 0) {
    return null;
  }

  return (
    <span className={styles.cartBadge}>
      <span className={styles.cartBadgeText}>{totalQuantity}</span>
    </span>
  );
};

export default CartBadge;
